/* eslint-disable */
import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, Output, signal } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskDirective } from "ngx-mask";
import { BasicFormInputComponent } from "../../basic/basic-form-input.component";
import { CabLabelComponent } from "../cab-label/cab-label.component";
import { IConfig } from "ngx-mask/lib/ngx-mask.config";

@Component({
  selector: "app-cab-input-percent",
  templateUrl: "./cab-input-percent.component.html",
  styleUrls: ["./cab-input-percent.component.scss"],
  standalone: true,
  imports: [
    NgClass,
    CabLabelComponent,
    FormsModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class CabInputPercentComponent extends BasicFormInputComponent {
  @Input() decimalMarker: IConfig["decimalMarker"] = ".";

  @Output() onInput = new EventEmitter();
  @Output() focus = new EventEmitter<FocusEvent>();
  @Output() blur = new EventEmitter<FocusEvent>();
  @Input() type:
    | "text"
    | "number"
    | "password"
    | "email"
    | "date"
    | "search"
    | "time"
    | "hidden" = "text";
  @Input() svgIcon = "";
  @Input() iconButton = "";
  @Input() keenIconName = "";
  @Input() keenIconClass = "";
  @Input() readonly = false;
  @Input() mask = "";
  @Input() prefix = "";
  @Input() suffix = "";
  @Input() step = "";
  @Input() allowNegativeNumbers = false;
  @Input() dropSpecialCharacters = true;
  @Input() showMaskTyped = false;
  @Input() isPending = false;
  @Input() patterns: any;
  @Input() max = Infinity;
  @Input() min = -Infinity;
  @Input() autocomplete = "on";

  handleFocus(event: FocusEvent) {
    this.focus.emit(event);
  }

  handleBlur(event: FocusEvent) {
    this.blur.emit(event);
  }
}
